export default {
      id: "icon-email-usage",
      viewBox: "0 0 22.997 18.069",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-email",
      toString: function () {
        return this.url;
      }
    }